import { Choice, Option } from "./types"

export const PATH = {
  brandDetails: "/brand/:id",
  invoiceDetailProcess: "/invoice/:id/process",
  invoiceDetailOfficeWork: "/invoice/:id/office",
  invoiceDetailWrapping: "/invoice/:id/wrapping",
  invoiceDetailLogistic: "/invoice/:id/logistic",
  invoiceDetailShipping: "/invoice/:id/shipping",
  invoiceDetailArrival: "/invoice/:id/arrival",
  invoiceDetails: "/invoice/:id",
  login: "/login",
  index: "/:page",
}

export const LOCALSTORAGE = {
  token: "token",
  usename: "usename",
  userId: "userId"
}

export enum InvStatus {
  CONFIRMED = "confirmed",
  NOT_CONFIRMED = "not yet confirmed",
  EXPORT = "exported"
}

export enum INVOICE_TAB_INDEX {
  CONTENT,
  PROCESS,
  OFFICE,
  WRAPPING,
  LOGISTIC,
  SHIPPING,
  ARRIVAL
}

export const StatusOptions: Choice[] = [
  {
    name: "未確定",
    value: InvStatus.NOT_CONFIRMED
  },
  {
    name: "確定済",
    value: InvStatus.CONFIRMED
  },
  {
    name: "請求書発行済",
    value: InvStatus.EXPORT
  }
]

export enum FILE_TYPES {
  csv = "text/csv",
  xls = "application/vnd.ms-excel",
  xlsx = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
};

export const cutoffDate: Choice[] = [
  {
    name: "　",
    value: ""
  },
  {
    name: "月末",
    value: "31"
  },
  {
    name: "5",
    value: "5"
  },
  {
    name: "10",
    value: "10"
  },
  {
    name: "15",
    value: "15"
  },
  {
    name: "20",
    value: "20"
  },
  {
    name: "25",
    value: "25"
  },
]

export enum ShippingCo {
  sagawa = "sagawa",
  yamato = "yamato"
}

export enum ShippingType {
  PIA = "PIA",
  COD = "COD"
}

export enum ShippingCoType {
  sPIA = "sagawaPIA",
  sCOD = "sagawaCOD",
  yPIA = "yamatoPIA",
  yCOD = "yamatoCOD"
}

export const ShippingTypeOptions: Option[] = [
  {value: 0, name: "元払い"},
  {value: 1, name: "着払い"},
]
